var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7125 13.5L3 16.5V4.5C3 4.30109 3.07902 4.11032 3.21967 3.96967C3.36032 3.82902 3.55109 3.75 3.75 3.75H15.75C15.9489 3.75 16.1397 3.82902 16.2803 3.96967C16.421 4.11032 16.5 4.30109 16.5 4.5V12.75C16.5 12.9489 16.421 13.1397 16.2803 13.2803C16.1397 13.421 15.9489 13.5 15.75 13.5H6.7125Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98 5.585C10.5 5.585 10.9175 5.7275 11.2325 6.0125C11.5525 6.2925 11.7125 6.68 11.7125 7.175C11.7125 7.665 11.555 8.04 11.24 8.3C10.925 8.555 10.5075 8.6825 9.9875 8.6825L9.9575 9.26H9.035L8.9975 7.985H9.335C9.77 7.985 10.105 7.9275 10.34 7.8125C10.575 7.6975 10.6925 7.4875 10.6925 7.1825C10.6925 6.9625 10.6275 6.7875 10.4975 6.6575C10.3725 6.5275 10.2 6.4625 9.98 6.4625C9.75 6.4625 9.57 6.525 9.44 6.65C9.315 6.775 9.2525 6.9475 9.2525 7.1675H8.2625C8.2575 6.8625 8.3225 6.59 8.4575 6.35C8.5925 6.11 8.79 5.9225 9.05 5.7875C9.315 5.6525 9.625 5.585 9.98 5.585ZM9.4925 11.0525C9.3025 11.0525 9.145 10.995 9.02 10.88C8.9 10.76 8.84 10.6125 8.84 10.4375C8.84 10.2625 8.9 10.1175 9.02 10.0025C9.145 9.8825 9.3025 9.8225 9.4925 9.8225C9.6775 9.8225 9.83 9.8825 9.95 10.0025C10.07 10.1175 10.13 10.2625 10.13 10.4375C10.13 10.6125 10.07 10.76 9.95 10.88C9.83 10.995 9.6775 11.0525 9.4925 11.0525Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5V17.25C7.5 17.4489 7.57902 17.6397 7.71967 17.7803C7.86032 17.921 8.05109 18 8.25 18H17.2875L21 21V9C21 8.80109 20.921 8.61032 20.7803 8.46967C20.6397 8.32902 20.4489 8.25 20.25 8.25H16.5",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.b1ff7645fc19c7a5b9aa75663fe51f3d.svg";
export { ForwardRef as ReactComponent };